import { faEllipsisV, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionIcon, Menu } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import type { TColumn } from 'components/SummaryTable/SummaryTable.types'
import { colors } from 'settings/colors'
import { ColumnVisibilityMenu } from './ColumnVisibilityMenu'

export const MenuWithVisibility = ({
  columns,
  visibleColumns,
  onToggle,
  onToggleAll,
}: {
  columns: TColumn[]
  visibleColumns: Record<string, boolean>
  onToggle: (key: string) => void
  onToggleAll: () => void
}) => {
  const [menuOpened, { toggle: toggleMenu }] = useDisclosure(false)

  return (
    <Menu shadow="md" width={200} opened={menuOpened} onChange={toggleMenu} position="bottom-end">
      <Menu.Target>
        <ActionIcon
          size="lg"
          variant="subtle"
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            e.stopPropagation() // Prevent accordion from toggling

            toggleMenu()
          }}
          sx={() => ({
            'borderRadius': '100px',
            '& svg': {
              color: menuOpened ? 'white' : colors.primary,
            },
            'backgroundColor': menuOpened ? colors.grey500 : 'transparent',
            '&:hover': {
              'backgroundColor': menuOpened ? colors.grey500 : colors.primary,
              '& svg': {
                color: 'white',
              },
            },
          })}
        >
          <FontAwesomeIcon icon={menuOpened ? faXmark : faEllipsisV} size="lg" />
        </ActionIcon>
      </Menu.Target>
      <ColumnVisibilityMenu
        columns={columns}
        visibleColumns={visibleColumns}
        onToggle={onToggle}
        onToggleAll={onToggleAll}
      />
    </Menu>
  )
}
